import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../../app-context';
import IGridComponent from '../../components/grid/i-grid.component';
import ISearchField from '../../components/text-component/search-field/i-searchfield.component';
import TitlePanel from '../../components/title-panel/title-panel.component';
import { EMPTY_STRING, PAGE_SIZE } from '../common/constants';
import { isEmptyArray, isNotEmpty } from '../common/util.services';
import './customer-list.component.scss';
import { deleteCustomer, getCustomer } from './customer.services';
import { Tooltip } from '@mui/material';

const CustomerList = () => {
  const appContext = useContext(AppContext);
  const navigate = useNavigate();
  const rows: GridRowsProp = [];
  const [role, setRole] = useState<String>('USER');
  const [customerData, setCustomerData] = useState(rows);
  const popperProps = {sx: {'.MuiTooltip-tooltip': {bgcolor: 'ivory', fontSize: 16, color: 'black', border: 1}}};
  const [searchText, setSearchText] = useState(EMPTY_STRING);
  const columns: GridColDef[] = [
    { field: 'name', headerName: 'Name', filterable: false, sortable: false, editable: false, width: 180 },
    { field: 'code', headerName: 'Code', filterable: false, sortable: false, editable: false, width: 120 },
    { field: 'type', headerName: 'Type', filterable: false, sortable: false, editable: false, width: 120 },
    { field: 'primaryContact', headerName: 'Primary Contact', filterable: false, sortable: false, editable: false, width: 135 },
    { field: 'primaryNumber', headerName: 'Primary Number', filterable: false, sortable: false, editable: false, width: 125 },
    { field: 'secondaryContact', headerName: 'Secondary Contact', filterable: false, sortable: false, editable: false, width: 150 },
    { field: 'secondaryNumber', headerName: 'Secondary Number', filterable: false, sortable: false, editable: false, width: 150 },
    { field: 'products', headerName: 'Products', filterable: false, sortable: false, editable: false, width: 100 },
    { field: 'city', headerName: 'City', filterable: false, sortable: false, editable: false, width: 100 },
    { field: 'address', headerName: 'Address', filterable: false, sortable: false, editable: false, width: 80,
      renderCell: (params: any) => <Tooltip title={(isNotEmpty(params.row.address1) ? (params.row.address1 + ', ') : '') +
                                                   (isNotEmpty(params.row.address2) ? (params.row.address2 + ', ') : '') +
                                                   (isNotEmpty(params.row.address3) ? (params.row.address3) : '')} 
                                                    PopperProps={popperProps}><span>
                                                  {(isNotEmpty(params.row.address1) ? (params.row.address1 + ', ') : '') +
                                                   (isNotEmpty(params.row.address2) ? (params.row.address2 + ', ') : '') +
                                                   (isNotEmpty(params.row.address3) ? (params.row.address3) : '')}</span></Tooltip>
    }
  ];
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    if (appContext.userData) {
      setRole(appContext.userData.role);
    }
    if (isEmptyArray(rows)) {
      getCustomer(searchText, page, pageSize, appContext,
        (response: any) => {
          setCustomerData(response.data.content);
          setTotalRows(response.data.totalElements);
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  }, [searchText, page, pageSize]);

  const handleEditAction = (row: any) => {
    navigate(EMPTY_STRING + row.rowId);
  };

  const handleDeleteAction = (row: any) => {
    deleteCustomer(row.rowId, appContext,
      (response: any) => {
        setCustomerData(customerData.filter((r) => r.rowId !== row.rowId));
        appContext.setSuccessMessage(response.message)
        appContext.setShowLoader(false);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message)
      });
  };


  const addCustomer = () => {
    navigate('new');
  }

  const search = (e: any) => {
    setSearchText(e);
  }

  const onPaginationModelChange = (evt: any) => {
    setPage(evt.page);
    setPageSize(evt.pageSize);
  }

  const getMainPanel = () => {
    return <>
      <ISearchField onActionEvent={search} />
      <IGridComponent title={''} rows={customerData} columns={columns} loading={loading}
        paginationType="server" paginationModelChange={onPaginationModelChange} totalRows={totalRows}
        showAction={'ADMIN' === role || 'LFHADMIN' === role || 'USER' === role || 'AMZUSER' === role || 'AMZUSEREDIT' === role}
        handleDeleteAction={handleDeleteAction} handleEditAction={handleEditAction} showApproveAction={false} 
        showAddBtn={'ADMIN' === role || 'LFHADMIN' === role || 'USER' === role || 'AMZUSER' === role || 'AMZUSEREDIT' === role}
        getRowId={(row: any) => row.rowId} addRow={addCustomer} maxHeight={450}/>
    </>
  }

  return <TitlePanel title='Customers' panelBody={getMainPanel()} />
}

export default CustomerList;